import { Component, EventEmitter, Input, Output} from '@angular/core';
import { ProjetAgenceModel, SchemaForms } from 'src/app/shared/models/simple-types/projet-models.model';
import { ProjetAgenceService } from 'src/app/shared/services/simple/projet-agence.service';
import { ProjetSchemaService } from 'src/app/shared/services/simple/projet-schema.service';

@Component({
  selector: 'app-all-projects',
  templateUrl: './all-projects.component.html',
  styleUrls: ['./all-projects.component.scss']
})
export class AllProjectsComponent {

  @Input() agenceId;
  @Output() changeProjetEmit = new EventEmitter<boolean>();
  schemaForms: SchemaForms;
  resultProjetAgence: ProjetAgenceModel[] = [];

  constructor(
    private projetAgenceService: ProjetAgenceService,
    private projetSchemaService: ProjetSchemaService
  ){}

  ngOnInit(): void {
    this.projetSchemaService.createForms().subscribe((schemaForms: SchemaForms) => {
      this.schemaForms = schemaForms;
    });
    this.projetAgenceService.getFromAgence(this.agenceId).subscribe((resultProjetAgence: ProjetAgenceModel[]) => {
      this.resultProjetAgence = Object.assign([], resultProjetAgence);
    });
  }

  emitChange(){
    this.changeProjetEmit.next(true);
  }

}
